import React from 'react'
import {Row, Col, Container } from 'react-bootstrap';
import '../styles/first.css';
function First() {
  return (
    <div className='bg-black py-3 '>
    
<Container > 

  <h1 className='text-start fw-bold text-light '>My Specialization</h1> <hr/>
<Row className="mt-2 mb-5 col-lg-11 mx-auto justify-content-center ">

          {[  'Quantum Computing Applications ',  
          '210+ Projects with 170K + Contributions In GitHub ', 
          'AI & ML Products Development ',
           'Big Data Engineer & Data Analyst',
           'BlockChain Technology & Decentralized apps ',
            'Project management & Technical Lead skills', 
            'AWS/ Google - Cloud Engineer',
            'UI/UX Design for Web/Mobile Applications', 
            ' Full Stack Web 3.0 Development',
             'Data Scientist & Business Analyst', 
             ' Android & IOS Mobile App Development', 
             'YouTuber - Skill Development Trainer' ].map((title, index) => (
            <Col xs={6} md={3} className="text-center mb-3" key={index}>
              <div className="side-box" style={{ color: '#fff' }}> 
                <i className={`bi ${index % 2 === 0 ? 'bi-stack' : 'bi-bar-chart'}`}></i>
                <p>{title}</p>
              </div>
            </Col>
          ))}
        </Row>
</Container>   
    </div>
  )
}

export default First;



